export default __webpack_public_path__ + "static/media/pause-quit-confirm.88bead7a.png";